import { useState, useCallback, useEffect } from "react";

interface UseHoverOptions {
  enterDelay?: number;
  leaveDelay?: number;
}

export const useHover = ({ enterDelay = 0, leaveDelay = 0 }: UseHoverOptions = {}): {
  isHovered: boolean;
  hoverProps: { onMouseEnter: () => void; onMouseLeave: () => void };
  forceHoverEnter: () => void;
  forceHoverLeave: () => void;
} => {
  const [isHovered, setIsHovered] = useState(false);
  const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);

  const clearHoverTimer = useCallback(() => {
    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }
  }, [timer]);

  useEffect(() => {
    return () => clearHoverTimer();
  }, [clearHoverTimer]);

  const hoverProps = {
    onMouseEnter: () => {
      clearHoverTimer();
      const newTimer = globalThis.setTimeout(() => {
        setIsHovered(true);
      }, enterDelay);
      setTimer(newTimer);
    },
    onMouseLeave: () => {
      clearHoverTimer();
      if (leaveDelay) {
        const newTimer = globalThis.setTimeout(() => {
          setIsHovered(false);
        }, leaveDelay);
        setTimer(newTimer);
      } else {
        setIsHovered(false);
      }
    },
  };

  const forceHoverEnter = () => {
    clearHoverTimer();
    setIsHovered(true);
  };

  const forceHoverLeave = () => {
    clearHoverTimer();
    setIsHovered(false);
  };

  return { isHovered, hoverProps, forceHoverEnter, forceHoverLeave };
};
